<template>
  <header>
    <slot></slot>
  </header>
</template>

<style scoped>
header {
  height: 365px;
  max-height: 365px;
  background-image: url("/rsz_dsc04054.jpg");
  background-position: 50% 50%;
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  align-items: flex-start;
  align-content: space-between;
  padding-top: 30px;
}
</style>
